'use strict';

require('../../style/index.less');

require('./index.less');

require('../../layout/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/form/style/index.tsx
 ** module id = 304
 ** module chunks = 0
 **/